import { IEntity } from './IEntity';

export const resourceNameGameIdentity = `gameidentity`;

export interface IGameIdentity extends IEntity {
	name: string;
	maxscore: number;
	erpgicon: number;
	power: string;
	iscombo: boolean;
	claimgoalid: number;
}
